import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({ uri: process.env.REACT_APP_APOLLO_URI });
const authLink = setContext((_, { headers }) => ({ headers: { ...headers } }));
const API = new ApolloClient({ link: authLink.concat(httpLink), cache: new InMemoryCache() });

export default API;
